import { render, staticRenderFns } from "./YogoIcon.vue?vue&type=template&id=744bca39&"
import script from "./YogoIcon.vue?vue&type=script&lang=js&"
export * from "./YogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports